import { cca_config } from '../../../../plugins/cca-config';
import EditTauxAssurance from '@/components/caisse/manage-bons/edit-taux-assurance';
import PaymentConfirmation from '@/components/caisse/manage-bons/confirm-payment'
import TicketCaisse from '@/components/caisse/ticket-caisse';
import PrintBonMedical from '@/components/caisse/manage-bons/print-bon-medical'
import GroupTaxation from '@/components/caisse/choix-groupe-taxation'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import $ from 'jquery'
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';

import store_consultation from "@/store/mods/clinique/consultations"
import store_operation from '@/store/mods/caisse/operations'
import medecinAttribution from './medecin-attribution'
import tarifManquant from './tarif-manquant'

// RDV-010 : note du bon généré depuis un rendez-vous, après l'enregistrement du bon — { texte, autre } ou null quand la
// Clinique a honoré ce rendez-vous. Au paiement, elle honore le rendez-vous planifié du jour du patient avec le médecin du
// bon (sans médecin d'un côté : de la même spécialité), le plus proche de l'arrivée ; un bon différé ne l'honore qu'à son
// règlement le jour même : le marquer honoré à la main avant ce règlement empêcherait ce lien.
function note_rdv_apres_bon(rdv, honore, etat_paiement, doctor_id) {
    if (honore && honore.rendez_vous_id && Number(honore.rendez_vous_id) !== Number(rdv.id)) {
        const heure = honore.heure_a_fixer ? '' : (honore.heure_locale || String(honore.date_rdv_locale || '').substr(11, 5))
        const quand = honore.heure_a_fixer ? ' (heure à fixer)' : (heure ? ' de ' + heure : '')
        const avec = honore.medecin_nom ? ' avec ' + honore.medecin_nom : ''
        return { autre: true, texte: 'Le rendez-vous' + quand + avec + ' a été marqué honoré à la place de celui-ci : vérifiez l’agenda.' }
    }
    if (honore) return null
    if (etat_paiement === 'differer') {
        const medecin = Number(doctor_id) || 0, medecin_rdv = Number(rdv.medecin_id) || 0
        if (!medecin || !medecin_rdv || medecin === medecin_rdv) {
            return { autre: false, texte: 'Paiement différé : le rendez-vous sera marqué honoré au règlement du bon, s’il est réglé aujourd’hui.' }
        }
    }
    return { autre: false, texte: 'Le rendez-vous n’a pas été marqué honoré automatiquement : marquez-le depuis l’agenda.' }
}

export default {
    name: 'bon-consultation',
    mixins: [medecinAttribution, tarifManquant],
    components: {
        EditTauxAssurance, PaymentConfirmation,
        TicketCaisse, EnteteBonEtFacture, GroupTaxation,
        PrintBonMedical
    },
    props: {
        // RDV-010 : « Générer le bon » de l'agenda — { id, patient_id, type_consultation_id, medecin_id, medecin_nom, heure,
        // heure_a_fixer }, passé par la route (jamais gardé dans le magasin) ; null dans le parcours normal
        rendez_vous: { type: Object, default: null }
    },
    data() {
        return {
            rdv_rafraichi: 0,   // RDV-005 : recharge le bloc « Prochain rendez-vous » quand le bon honore un rendez-vous
            note_rdv_paiement: '',   // RDV-010 : bon enregistré sans que la Clinique honore ce rendez-vous (différé, autre)
            vm_state: open_menu_state,
            is_loading: true,
            expiration_date: '',
            moment_selected: '',
            moment_initialise: false,
            is_loading_tarif: true,
            is_printing: false,

            selected_consumable: [],
            prix_consultation: 0,
            prix_net_consultation: 0,
            tmp_prix_consultation: 0,
            taxe_additionnel: 0,
            total_net_a_payer: 0,
            taux_couverture: '',
            base_assurance: '',
            tmp_base_assurance: 0,
            tmp_prix_assure_clinique: 0,

            prestations: [],
            consultation_data: {},
            prix_assure: 0,
            prix_assureur: 0,
            total_a_payer: 0,
            total_prix_vente: 0,
            total_consommable: 0,
            is_reloading_tarif: false,

            can_pay: true,

            can_apply_apport: true,
            error_message: "",
            pa_undifined_error_msg: "",
            apport_social_error_message: "",
            duree_bon_error_message: "",
            duree_bon_is_set: true,
            warning_message: "",
            warning_exclusion: "",
            warning_contrat_expire: "",
            warning_prestations: [],
            warning_pa_undefined: [],
            toggle_payment_state: 0,
            etat_paiement: '',

            compte_id: 0,
            can_pay_with_deposit: false,
            depot_data: {},
            info_assurance: {},
            is_printable: false,
            consultation_payment_recorded: false,
            bon_creation_en_cours: false,
            bon_creation_source: null,
            bon_creation_payload: null,

            prestation_data: {
                data_type: 'bon_consultation',
                libelle: 'Bon de consultation'
            },

            paiement_data: {
                montant_du: '',
                montant_recu: '',
                montant_net_paye: '',
                reliquat_remis: '',
                reliquat: '',
                reste_a_payer: '',
            },
            ticket_caisse_info: {},
            filename: '',
            today_date: '',

            aib_liste: [
                {
                    libelle: 'N/A',
                    taux: 0,
                    slug: 'n_a'
                }
            ],
            selected_aib: {
                libelle: 'N/A',
                taux: 0,
                slug: 'n_a'
            },

            groupes_taxation: [],
            type_factures: [],
            taxation_data: {},
            taxation_togller: 0,

            ventilation_impots: [],
            recap_ventilation_impots: {},
            sfe_data: {},

            total_taxe_specifique: 0,
            total_imposable_aib: 0,
            impot_aib: 0,
            current_taxation: {},
            can_show_groupe_for_prestation: false,

            nom_clinique: '',
            prix_apport_social: 0,
            duree_validite: '',
            validite_bon: {},

            colspans: {
                colspan_1: '',
                colspan_2: '',
            },
            consumable_is_empty: true,
            info_caissier: {},
            warning_fe_choice: "",
            can_print_consultation: false,
            bon_is_printable: false,
            save_loading: false,
            msg_error: '',
            info_bon: {},
            is_bon_consultation: true,
            a_model_forfait: 0,
            num_bon_societe: '',
            date_expire_bon: '', 
            num_bon_is_empty: false,
            date_is_empty: false,
            old_bon_societe: '',
            num_bon_is_expired: 0,

            info_bon_loading: true
        }
    },

    watch: {
        moment_selected() {
            // Le tarif initial (moment « jour ») est déjà chargé avec la vérification du bon.
            // Le premier changement vient de la liste des moments, pas de l'utilisateur.
            if (!this.moment_initialise) {
                this.moment_initialise = true
                if (Number(this.moment_selected) === 1) return
            }
            const tarif_data = {
                patient_id: this.chosen_patient.id,
                type_consultation_id: this.selected_type_consultation.consult_id,
                moment_consultation_id: this.moment_selected,
                can_set_pac: this.can_set_pac
            }
            this.getTarifConsultation(tarif_data)
        },

        selected_consumable: {
            handler() {
                console.log("change in consumable");
                
                this.calculate_prix_a_payer()
                this.checkIfConsumableEmpty()
    
                if (cca_config.IS_SFE) {
                    this.removeItemFromVentilation()
                }
            },
            deep: true
        },

        selected_aib() {
            if (Object.prototype.hasOwnProperty.call(this.current_taxation, 'group_taxation')) {
                this.handleVentilationCalculation(this.current_taxation)
                this.calculate_prix_a_payer()
            }
        },

        num_bon_societe() {
            this.num_bon_is_empty = false
        },

        date_expire_bon() {
            this.date_is_empty = false
        }
    },

    computed: {
        minDateExpireBon() {
            const today = new Date()
            const year = today.getFullYear()
            const month = String(today.getMonth() + 1).padStart(2, '0')
            const day = String(today.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },

        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        patient() {
            return this.$store.getters["patient"];
        },

        chosen_patient() {
            return this.$store.getters["chosen_patient"];
        },

        selected_type_consultation() {
            return this.$store.getters["typeConsSelected"]
        },

        patient_has_ongoing_type_consultation() {
            return this.$store.getters["patient_has_ongoing_type_consultation"];
        },

        tarif_consultation() {
            return this.$store.getters["tarif_consultation"];
        },

        moment_consultations() {
            return this.$store.getters['moment_consultations']
        },

        bon_consommables() {
            return this.$store.getters["bon_consommables"]
        },

        can_add_differential_computing() {
            return this.$store.getters["can_add_differential_computing"]
        },

        depot_patient() {
            return this.$store.getters['depot_patient'];
        },

        sfe_type_facture() {
            return this.$store.getters['sfe_type_facture'];
        },

        sfe_type_paiement() {
            return this.$store.getters['sfe_type_paiement'];
        },

        sfe_liste_aib() {
            return this.$store.getters['sfe_liste_aib'];
        },

        sfe_groupes_taxation() {
            return this.$store.getters['sfe_groupes_taxation'];
        },

        divers_info() {
            return this.$store.getters["divers_info"];
        },

        is_pre_saved_bon() {
            return this.$store.getters["is_pre_saved_bon"];
        },

        selected_bon_consommables() {
            return this.$store.getters["selected_bon_consommables"];
        },

        // RDV-010 : bandeau discret du bon ouvert depuis un rendez-vous — « Bon du rendez-vous de 10:30 avec Dr X »,
        // « (heure à fixer) » sans heure ; patient en suite de soins : aucun bon à payer, le rendez-vous se marque à l'agenda
        banniere_rdv() {
            const rdv = this.rdv_bon
            if (!rdv) return ''
            const quand = rdv.heure ? 'de ' + rdv.heure : '(heure à fixer)'
            const avec = rdv.medecin_nom ? ' avec ' + rdv.medecin_nom : ''
            if (this.patient_has_ongoing_type_consultation == 1) {
                return 'Rendez-vous ' + quand + avec + ' : patient en suite de soins, aucun bon à payer. Marquez le rendez-vous honoré depuis l’agenda.'
            }
            return 'Bon du rendez-vous ' + quand + avec
        }
    },

    mounted() {
        if (this.has_two_currencies) {
            this.currency_info = this.$store.getters['info_currency']
        }
        
        this.setColspans() 
        // The global mixin already uses the establishment name saved in Clinique.
        // Do not replace it with the build-time demo label.

        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        this.info_caissier = {
            nom_caissier: this.userCredentials.user.name,
            titre: this.userCredentials.user.titre
        }

        // Check patient ongoing type of consultation
        this.checkPatientOnGoingConsultation()

        // Check depot patient
        this.checkDepotPatient()

        // Consommable de Bon de consultation
        this.$store.dispatch('getConsommableBonForTypeConsultation', {
            type_consultation_id: this.selected_type_consultation.consult_id
        }).then(() => {
            if (this.bon_consommables.length > 0) {
                console.log(">>bc: ",this.bon_consommables);
                console.log("s bc: ",this.selected_bon_consommables);
                
                
                for (let index = 0; index < this.bon_consommables.length; index++) {
                    this.$set(this.selected_consumable, index, false)

                    if (this.is_pre_saved_bon === true) {
                        // check if the consommable is in selected_bon_consommables
                        const consommable_in_selected = this.selected_bon_consommables.find(consommable => consommable.consommable === this.bon_consommables[index].consommable)
                        if (consommable_in_selected) {
                            this.$set(this.selected_consumable, index, true)
                        }

                    }
                }
            }
        })


        // Check if Differential computing should be applied
        this.$store.dispatch('getDifferentialComputing')

        this.getDureeBonConsultation()

        if (cca_config.IS_SFE) {
            // Type facture SFE
            this.getTypeFacturesSFE()

            // Type paiement SFE
            this.getTypePaiementSFE()

            // AIB SFE
            this.getListeAibSFE()

            // Groupe taxation
            this.getGroupeTaxationSFE()
        }

        this.initPrestationsGroupTaxation()
        this.initVentilationImpot()

        const ts = this;
        $(document).on('click.bon-consultation-' + this._uid, function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("option-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'option-box', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        this.getDiversInfo()
    },

    beforeDestroy() {
        $(document).off('click.bon-consultation-' + this._uid)
    },

    methods: {
        getDiversInfo() {
            this.$store.dispatch('getConfigInfoClinique', 'divers_info')
        },

        checkIfConsumableEmpty() {
            this.consumable_is_empty = true
            this.selected_consumable.forEach(el => {
                if (el) {
                    this.consumable_is_empty = false
                }
            });
        },

        validateExpireBonDate() {
            if (this.date_expire_bon && this.date_expire_bon < this.minDateExpireBon) {
                this.date_expire_bon = this.minDateExpireBon
            }
        },

        setColspans() {
            if (this.is_sfe) {
                this.colspans.colspan_1 = 4
                this.colspans.colspan_3 = 4

                if (this.can_set_pac) {
                    this.colspans.colspan_2 = 6
                } else {
                    this.colspans.colspan_2 = 5
                }
            } else {
                this.colspans.colspan_1 = 3
                this.colspans.colspan_3 = 3

                if (this.can_set_pac) {
                    this.colspans.colspan_2 = 5
                } else {
                    this.colspans.colspan_2 = 4
                }
            }
        },

        getDureeBonConsultation() {
            let data = {
                type_consultation_id: this.selected_type_consultation.consult_id
            }
            store_consultation.getDureeValiditeConsultation(data).then((response) => {
                this.validite_bon = response
                this.duree_validite = response.duree_en_secondes

                if (response.duree_bon > 0) {
                    this.duree_bon_is_set = true
                    this.duree_bon_error_message = ''
                } else {
                    this.duree_bon_is_set = false
                    this.duree_bon_error_message = "Merci de renseigner la durée du bon de consultation dans les paramètres"
                }

                this.setExpirationDate()  
            })
        },

        /**
         * Open Menu Dropdown
         */
        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        getTypeFacturesSFE() {
            const data = {
                data_type: 'invoice_type',
                endpoint: 'invoiceTypes'
            }
            this.$store.dispatch('getInfoSFE', data).then(() => {
                this.sfe_type_facture.forEach(bill_type => {
                    if (bill_type.type === 'FV' || bill_type.type === 'EV') {
                        const tmp_aib = {
                            description: bill_type.description,
                            type: bill_type.type
                        }
                        this.type_factures.push(tmp_aib)
                    }
                });
            })
        },

        getTypePaiementSFE() {
            const data = {
                data_type: 'payment_type',
                endpoint: 'paymentTypes'
            }
            this.$store.dispatch('getInfoSFE', data)
        },

        getGroupeTaxationSFE() {
            const data = {
                data_type: 'taxation_type',
                endpoint: 'taxGroups'
            }
            this.$store.dispatch('getInfoSFE', data).then(() => {
                const groupe_taxation = Object.keys(this.sfe_groupes_taxation);

                const taxation_items = ['a', 'b', 'c', 'd', 'e', 'f']
                groupe_taxation.forEach(key => {
                    if (taxation_items.includes(key)) {
                        const tmp_aib = {
                            libelle: this.setLibelleGroupTaxation(key),
                            taux: this.sfe_groupes_taxation[key],
                            slug: key
                        }
                        this.groupes_taxation.push(tmp_aib)
                    }
                });
            })
        },

        async initVentilationImpot() {
            const data = {
                data_type: 'taxation_type',
                endpoint: 'taxGroups'
            }
            await this.$store.dispatch('getInfoSFE', data).then(() => {
                const groupe_taxation = Object.keys(this.sfe_groupes_taxation);

                const taxation_items = ['a', 'b', 'c', 'd', 'e', 'f']
                groupe_taxation.forEach(key => {
                    if (taxation_items.includes(key)) {
                        const tmp_ventilation = {
                            libelle: this.setLibelleGroupTaxation(key),
                            taux: this.sfe_groupes_taxation[key],
                            impot: 0, 
                            imposable: 0,
                            total: 0,
                            can_show: false,
                            prestations: []
                        }
                        this.ventilation_impots.push(tmp_ventilation)
                    }
                });
            })
        },

        getListeAibSFE() {
            const data = {
                data_type: 'taxation_type',
                endpoint: 'taxGroups'
            }
            this.$store.dispatch('getInfoSFE', data).then(() => {
                const listes_aib = Object.keys(this.sfe_liste_aib);
                const aib_items = ['aibA', 'aibB']

                listes_aib.forEach(key => {
                    if (aib_items.includes(key)) {
                        const tmp_aib = {
                            libelle: this.setLibelleGroupTaxation(key),
                            taux: this.sfe_liste_aib[key],
                            slug: key
                        }
                        this.aib_liste.push(tmp_aib)
                    }
                });
            })
        },

        initPrestationsGroupTaxation() {
            this.selected_type_consultation.group_taxation = ''
            this.selected_type_consultation.slug_taxation = ''
            this.selected_type_consultation.taxe_specifique = ''
        },

        setGroupTaxation(data_type, prestation, prix, is_grouped) {
            let prix_prestation = 0
            let libelle_prestation = ""
            if (!is_grouped) {
                if (this.tarif_consultation.est_assure) {
                    if (data_type == 'bon') {
                        prix_prestation = this.prix_assure
                    } else {
                        prix_prestation = prix
                    }
                } else {
                    prix_prestation = prix
                }

                libelle_prestation = (data_type === 'bon')?prestation.consult_name:prestation.consommable
            } else {
                libelle_prestation = "Tous les consommables"
            }
            
            const tmp_group_taxation = this.groupes_taxation[0]

            this.taxation_data = {
                data_type: data_type,
                prestation: libelle_prestation,
                uid: "",
                group_taxation: (!is_grouped)?prestation.group_taxation:tmp_group_taxation,
                taxe_specifique: (!is_grouped)?prestation.taxe_specifique:"",
                prix: prix_prestation,
                is_grouped: is_grouped,
                index: 0
            }

            this.taxation_togller = (this.taxation_togller == 0)?1:0
        },

        setGroupTaxationToUpdate(data) {
            if (data.is_grouped) {
                this.fillAllConsommableGroupTaxation(data.group_taxation, data.taxe_specifique)
            } else {
                this.updateGroupTaxation(data)
            }
        },

        fillAllConsommableGroupTaxation(group_taxation, taxe_specifique) {
            let valeur_ajoutee = 0
            this.warning_prestations = []
            this.warning_message = ""

            this.bon_consommables.forEach((consumable, index) => {
                if (this.selected_consumable[index] && consumable.consommable != 'Apport social') {
                    this.bon_consommables[index].group_taxation = group_taxation
                    this.bon_consommables[index].taxe_specifique = taxe_specifique
                    this.bon_consommables[index].slug_taxation = this.capitalizeFirstLetter(group_taxation.slug)

                    if (taxe_specifique > 0) {
                        valeur_ajoutee = parseFloat( taxe_specifique * (1 + (group_taxation.taux / 100)) ).toFixed(0)
                        valeur_ajoutee = parseInt(valeur_ajoutee)
                        this.bon_consommables[index]['consommable_prix_net'] = this.bon_consommables[index]['consommable_prix'] + valeur_ajoutee
                    } else {
                        this.bon_consommables[index]['consommable_prix_net'] = this.bon_consommables[index]['consommable_prix']
                    }

                    const info_taxation = {
                        group_taxation: group_taxation,
                        prestation: consumable.consommable,
                        taxe_specifique: consumable.taxe_specifique,
                        prix: consumable.consommable_prix,
                        qte: 1
                    }
                    this.updateGroupTaxation(info_taxation)
                }
            });
        },

        updateGroupTaxation(data) {
            let valeur_ajoutee = 0
            this.warning_prestations = []
            this.warning_message = ""

            if (data.data_type == 'bon') {
                this.selected_type_consultation.group_taxation = data.group_taxation
                this.selected_type_consultation.taxe_specifique = data.taxe_specifique
                this.selected_type_consultation.slug_taxation = this.capitalizeFirstLetter(data.group_taxation.slug)

                if (data.taxe_specifique > 0) {
                    valeur_ajoutee = parseFloat( data.taxe_specifique * (1 + (data.group_taxation.taux / 100)) ).toFixed(0)
                    valeur_ajoutee = parseInt(valeur_ajoutee)
                    this.prix_net_consultation = this.tmp_prix_consultation + valeur_ajoutee
                    this.taxe_additionnel = valeur_ajoutee
                } else {
                    this.prix_net_consultation = this.tmp_prix_consultation
                    this.taxe_additionnel = 0
                }
            } else {
                this.bon_consommables.forEach((consumable, index) => {
                    if (consumable.consommable == data.prestation) {
                        this.bon_consommables[index].group_taxation = data.group_taxation
                        this.bon_consommables[index].taxe_specifique = data.taxe_specifique
                        this.bon_consommables[index].slug_taxation = this.capitalizeFirstLetter(data.group_taxation.slug)

                        if (data.taxe_specifique > 0) {
                            valeur_ajoutee = parseFloat( data.taxe_specifique * (1 + (data.group_taxation.taux/ 100)) ).toFixed(0)
                            valeur_ajoutee = parseInt(valeur_ajoutee)
                            this.bon_consommables[index]['consommable_prix_net'] = this.bon_consommables[index]['consommable_prix'] + valeur_ajoutee
                        } else {
                            this.bon_consommables[index]['consommable_prix_net'] = this.bon_consommables[index]['consommable_prix']
                        }
                    }
                });
            }

            this.handleVentilationCalculation(data)
            this.calculate_prix_a_payer()
        },

        resetValue(index) {
            this.ventilation_impots[index]['total'] = 0
            this.ventilation_impots[index]['imposable'] = 0
            this.ventilation_impots[index]['impot'] = 0
        },

        removeItemFromVentilation() {
            this.bon_consommables.forEach((consumable, ci) => {

                this.ventilation_impots.forEach((ventilation, index) => {

                    let sfe_tot = 0
                    let sfe_impot = 0
    
                    ventilation.prestations.forEach((prestation, pi) => {
                        if (!this.selected_consumable[ci] && consumable.consommable == prestation.libelle) {
                            consumable.group_taxation = ''
                            consumable.slug_taxation = ''
                            
                            
                            this.ventilation_impots[index]['prestations'].splice(pi, 1)
        
                            this.ventilation_impots[index]['total'] -= (consumable.consommable_prix_net)
                            sfe_tot = this.ventilation_impots[index]['total']

                            if (consumable.taxe_specifique > 0) {
                                this.total_taxe_specifique -= consumable.taxe_specifique
                            }
        
                            // Calcul imposable
                            if (ventilation.taux > 0) {
                                this.ventilation_impots[index]['imposable'] = parseInt(this.ventilation_impots[index]['imposable'])
                                this.ventilation_impots[index]['imposable'] = ( this.ventilation_impots[index]['total'] / (1 + prestation.taux/100) )
                                this.ventilation_impots[index]['imposable'] = parseFloat(this.ventilation_impots[index]['imposable']).toFixed(0)
        
                                // Calcul impot 
                                this.ventilation_impots[index]['impot'] = this.ventilation_impots[index]['total'] - this.ventilation_impots[index]['imposable'] 
                                sfe_impot = this.ventilation_impots[index]['impot'] 
                            }

                            // Calcul AIB
                            if (this.selected_aib.libelle != 'N/A') {
                                this.total_imposable_aib -= consumable.consommable_prix_net
                                this.impot_aib = parseFloat((this.selected_aib.taux / 100) * this.total_imposable_aib).toFixed(0)
                            } else {
                                this.total_imposable_aib = 0
                                this.impot_aib = 0
                            }

        
                            consumable.consommable_prix_net = consumable.consommable_prix
                            consumable.taxe_specifique = ''
                        }
                    });

                    console.log("", sfe_tot, " >> ",sfe_impot);
    
                    // Bon conultation
                    let can_show_groupe_for_bon = false
                    if (ventilation.libelle === this.selected_type_consultation.group_taxation.libelle) {
                        can_show_groupe_for_bon = true
                    }
    
                    // Consommables de bon
                    let can_show_groupe_for_consommable = false
                    this.bon_consommables.forEach((consumable) => {
                        if (ventilation.libelle === consumable.group_taxation.libelle) {
                            can_show_groupe_for_consommable = true
                        }
                    });
    
                    // Eliminate not chosen group from ventilation impots
                    if (!can_show_groupe_for_bon && !can_show_groupe_for_consommable) {
                        this.ventilation_impots[index]['can_show'] = false
                        this.resetValue(index)
                    }
                })
            });

            
        },

        handleVentilationCalculation(taxation) {
            this.current_taxation = taxation
            this.total_taxe_specifique = 0
            this.total_imposable_aib = 0
            this.impot_aib = 0

            this.ventilation_impots.forEach((ventilation, index) => {
                if (ventilation.libelle == taxation.group_taxation.libelle) {
                    this.ventilation_impots[index]['can_show'] = true

                    let is_new = true

                    const tmp_ventilation_prestation = {
                        libelle: taxation.prestation,
                        prix: taxation.prix,
                        taxe_specifique: taxation.taxe_specifique, 
                        taux: taxation.group_taxation.taux, 
                    }
                    this.ventilation_impots[index]['prestations'].forEach((prestation, j) => {
                        if (prestation.libelle == taxation.prestation) {
                            is_new = false
                            this.ventilation_impots[index]['prestations'][j]['taxe_specifique'] = taxation.taxe_specifique
                        }
                    });

                    if (is_new) {
                        this.ventilation_impots[index]['prestations'].push(tmp_ventilation_prestation)
                    }
                } else {
                    this.ventilation_impots[index]['prestations'].forEach((prestation, pi) => {
                        if (prestation.libelle == taxation.prestation) {
                            this.ventilation_impots[index]['prestations'].splice(pi, 1)
                        } 
                    });
                }

                this.resetValue(index)
                let sfe_tot = 0
                let sfe_impot = 0
                this.ventilation_impots[index]['prestations'].forEach((prestation, pi) => {
                    if (taxation.prestation == prestation.libelle) {
                        this.ventilation_impots[index]['prestations'][pi]['prix'] = taxation.prix
                        this.ventilation_impots[index]['prestations'][pi]['taxe_specifique'] = taxation.taxe_specifique
                    }

                    let valeur_ajoutee = 0
                    if (prestation.taxe_specifique > 0) {
                        valeur_ajoutee = parseFloat( prestation.taxe_specifique * (1 + (prestation.taux / 100)) ).toFixed(0)

                        this.total_taxe_specifique += prestation.taxe_specifique
                    }
                    valeur_ajoutee = parseInt(valeur_ajoutee)
                    this.ventilation_impots[index]['total'] += (prestation.prix + valeur_ajoutee)
                    sfe_tot = this.ventilation_impots[index]['total']

                    // Calcul imposable
                    if (prestation.taux > 0) {
                        this.ventilation_impots[index]['imposable'] = parseInt(this.ventilation_impots[index]['imposable'])
                        this.ventilation_impots[index]['imposable'] = ( this.ventilation_impots[index]['total'] / (1 + prestation.taux/100) )
                        this.ventilation_impots[index]['imposable'] = parseFloat(this.ventilation_impots[index]['imposable']).toFixed(0)
                        this.ventilation_impots[index]['imposable'] = parseInt(this.ventilation_impots[index]['imposable'])

                        // Calcul impot 
                        this.ventilation_impots[index]['impot'] = this.ventilation_impots[index]['total'] - this.ventilation_impots[index]['imposable'] 
                        sfe_impot = this.ventilation_impots[index]['impot'] 
                    }

                    
                });

                // Calcul AIB
                if (this.selected_aib.libelle != 'N/A') {
                    this.total_imposable_aib += (sfe_tot - sfe_impot)
                }

                this.impot_aib = parseFloat((this.selected_aib.taux / 100) * this.total_imposable_aib).toFixed(0)
                this.impot_aib = parseInt(this.impot_aib)

                // Bon conultation
                let can_show_groupe_for_bon = false
                if (ventilation.libelle === this.selected_type_consultation.group_taxation.libelle) {
                    can_show_groupe_for_bon = true
                }

                // Consommables de bon
                let can_show_groupe_for_consommable = false
                this.bon_consommables.forEach((consumable) => {
                    if (ventilation.libelle === consumable.group_taxation.libelle) {
                        can_show_groupe_for_consommable = true
                    }
                });

                // Eliminate not chosen group from ventilation impots
                if (!can_show_groupe_for_bon && !can_show_groupe_for_consommable) {
                    this.ventilation_impots[index]['can_show'] = false
                    this.resetValue(index)
                }
            });

            this.ventilation_impots.forEach(ventilation => {
                if (ventilation.can_show == true) {
                    this.can_show_groupe_for_prestation = true
                }
            });
        },

        checkChosenGroupTaxation(vm_state, down_option_box, animate_zoomIn, animate_zoomOut) {
            if (cca_config.IS_SFE) {
                this.warning_prestations = []

                if (this.selected_type_consultation.group_taxation == "") {
                    this.warning_prestations.push(
                        {
                            libelle: this.selected_type_consultation.consult_name
                        }
                    )
                }
            
                this.bon_consommables.forEach((consumable, index) => {
                    if (this.selected_consumable[index]) {
                        if (consumable.group_taxation == "" && consumable.consommable != "Apport social") {
                            this.warning_prestations.push(
                                {
                                    libelle: consumable.consommable
                                }
                            )
                        }
                    }
                });

                if (this.warning_prestations.length > 0) {
                    this.warning_message = "Le groupe de taxation d'une ou plusieurs prestations n'a pas été défini !"
                }

                if (this.warning_message != "") {
                    return;
                }
            }

            this.openMenu(vm_state, down_option_box, animate_zoomIn, animate_zoomOut)
        },

        checkDepotPatient() {
            // Depot patient
            this.$store.dispatch('getDepotPatient', this.chosen_patient.id).then(() => {
                if (this.depot_patient.length == 0) {
                    this.can_pay_with_deposit = false
                } else {
                    this.can_pay_with_deposit = true
                }
            })
        },

        getMomementConsultation(moment) {
            let designation = ''
            switch (moment) {
                case 'jour':
                    designation = 'de jour'
                    break
                case 'nuit':
                    designation = 'de nuit'
                    break 
                case 'férié':
                    designation = 'de jour férié'
                    break 
                case 'garde':
                    designation = 'de garde'
                    break
                case 'urgence':
                    designation = 'en urgence'
                    break
                default:
                    designation = ''
                    break
            }
            return designation
        },

        payWithDeposit() {
            this.depot_data = {}
            if (this.etat_paiement == 'depot') {
                this.depot_data = this.depot_patient
            }
        },

        async onPayment(etat_paiement) {
            if (this.medecin_verifying || this.consultation_payment_recorded || !this.can_pay || this.is_loading_tarif || this.tarif_manquant_busy || this.tarif_a_recharger) return
            this.medecin_verifying = true
            const validMedecin = await this.verifierMedecin()
            this.medecin_verifying = false
            if (!validMedecin || !this.can_pay || this.is_loading_tarif || this.tarif_manquant_busy || this.tarif_a_recharger) return
            this.figerMedecinPaiement()
            if(
                this.info_assurance.est_assure === 1 && 
                this.info_assurance.num_bon_is_required === 1
            ) {
                if (this.num_bon_societe == '' || this.num_bon_societe == null) {
                    this.num_bon_is_empty = true
                    return;   
                }

                if (this.date_expire_bon == '' || this.date_expire_bon == null) {
                    this.date_is_empty = true
                    return;
                }
            }

            this.etat_paiement = etat_paiement
            this.info_assurance.num_bon_societe = this.num_bon_societe

            this.payWithDeposit()
            
            this.toggle_payment_state = (this.toggle_payment_state == 0)?1:0

            let moment_consulatation = ''
            this.moment_consultations.forEach(moment => {
                if (moment.id == this.moment_selected) {
                    moment_consulatation = moment.denomination
                }
            });

            const part_assure = this.prix_assure + this.taxe_additionnel

            let is_facture_compl = 1;
            if (this.a_model_forfait === 1) {
                is_facture_compl = 0   // consommation réelle

                if (this.tarif_consultation.est_exclu === 1) {
                    is_facture_compl = 1
                }
            }

            // Bon consultation
            this.consultation_data = {
                data_type: 'bon_consultation',
                id: this.selected_type_consultation.consult_id,
                libelle: this.selected_type_consultation.consult_name+' '+this.getMomementConsultation(moment_consulatation),
                prix: this.prix_consultation,
                prix_clinique: this.prix_consultation,
                prix_vente: (this.tarif_consultation.est_assure == 1)?part_assure:this.prix_net_consultation,
                group_taxation: this.selected_type_consultation.group_taxation,
                taxe_specifique: this.selected_type_consultation.taxe_specifique,
                net_paye: 0,
                base_assurance: this.tmp_base_assurance,
                prix_assure_clinique: this.tmp_prix_assure_clinique,
                part_assureur: this.prix_assureur,
                qte: 1,
                est_exclu: this.tarif_consultation.est_exclu,
                is_facture_compl: is_facture_compl
            }

            // Consommables de bon
            this.prestations = []
            this.bon_consommables.forEach((consumable, index) => {
                if (this.selected_consumable[index]) {
                    const tmp_consumable = {
                        data_type: 'consommable_bon',
                        id: '',
                        libelle: consumable.consommable,
                        prix: consumable.consommable_prix,
                        prix_clinique: consumable.consommable_prix,
                        prix_vente: consumable.consommable_prix_net,
                        group_taxation: consumable.group_taxation,
                        taxe_specifique: consumable.taxe_specifique,
                        net_paye: 0,
                        base_assurance: 0,
                        part_assureur: 0,
                        prix_assure_clinique: null,
                        coupon_remise: 0,
                        qte: 1
                    }
                    this.prestations.push(tmp_consumable)
                }
            });

            if (!cca_config.IS_SFE) {
                this.selected_aib = {
                    libelle: '',
                    taux: 0,
                    slug: ''
                }
            }

            this.recap_ventilation_impots = this.ventilation_impots.filter((ventilation) => ventilation.can_show)
            this.sfe_data = {
                recap_ventilation_impots: this.recap_ventilation_impots,
                total_taxe_specifique: this.total_taxe_specifique,
                info_aib: this.selected_aib,
                impot_aib: this.impot_aib,
                total_imposable_aib: this.total_imposable_aib
            }

            setTimeout(() => {
                $('.cfrm-payment').modal('show')
            }, 100);
        },

        // Set Expiration date of the bon consultation based on this.duree_validite which is in seconds
        setExpirationDate() {
            // after setting the expiration date, convert to dd/mm/YYYY format
            const current_date = new Date()
            const expiration_date = new Date(current_date.getTime() + this.duree_validite * 1000)

            // Convert to dd/mm/YYYY format
            const day = ("0" + expiration_date.getDate()).slice(-2)
            const month = ("0" + (expiration_date.getMonth() + 1)).slice(-2)
            const year = expiration_date.getFullYear()
            this.expiration_date = day + '/' + month + '/' + year

            // Today date in dd/mm/YYYY format
            this.today_date = this.formatDateToDmY(new Date())

            // if this.validite_bon.unite_duree === 'heures', then add also hours and minutes to the expiration date
            if (this.validite_bon.unite_duree === 'heures') {
                const hours = ("0" + expiration_date.getHours()).slice(-2)
                const minutes = ("0" + expiration_date.getMinutes()).slice(-2)
                this.expiration_date += ' à ' + hours + 'h' + minutes

                this.today_date = this.formatDateToDateHour(new Date())
            }
        },
        

        /**
         * Check if Patient has the same type of consultation running by then
         */
        checkPatientOnGoingConsultation() {
            const data = {
                patient_id: this.chosen_patient.id,
                type_consultation_id: this.selected_type_consultation.consult_id
            }
            const tarif_data = {
                patient_id: this.chosen_patient.id,
                type_consultation_id: this.selected_type_consultation.consult_id,
                moment_consultation_id: 1,
                can_set_pac: this.can_set_pac,
                avec_verification_bon: true
            }
            this.$store.dispatch('getTarifConsultation', tarif_data).then(reponse => {
                if (Array.isArray(reponse.moments_consultations)) {
                    this.$store.commit('SET_MOMENT_CONSULTATIONS', reponse.moments_consultations)
                    if (this.moment_consultations.length) this.moment_selected = this.moment_consultations[0].id
                } else {
                    // Ancien serveur : récupérer la liste sans bloquer l'affichage du tarif.
                    this.$store.dispatch('getMomentsConsultations').then(() => {
                        if (this.moment_consultations.length) this.moment_selected = this.moment_consultations[0].id
                    })
                }
                const terminer = () => {
                    if (this.patient_has_ongoing_type_consultation == 1) {
                        this.is_loading = false
                    } else {
                        this.getTarifConsultation(tarif_data, Promise.resolve(true))
                    }
                }
                if (reponse.patient_has_ongoing_type_consultation === undefined) {
                    // Compatibilité avec un serveur encore sur l'ancienne version.
                    return this.$store.dispatch('checkIfPatientHasOnGoingTypeConsultation', data).then(terminer)
                }
                this.$store.commit('SET_PATIENT_HAS_ONGOING_TYPE_CONSULTATION', Number(reponse.patient_has_ongoing_type_consultation))
                terminer()
            }).catch(() => {
                this.is_loading = false
                this.is_loading_tarif = false
                this.error_message = 'Impossible de préparer le bon de consultation. Réessayez.'
            })
        },

        validator() {
            this.error_message = ""

            if (this.is_loading_tarif || this.validateStringNotEmpty(this.prix_consultation)) {
                this.can_pay = false
                this.error_message = this.is_loading_tarif ? 'Vérification du tarif en cours…' : "Le prix de cette consultation n'a pas été défini"
                return
            }

            if (
                (this.tarif_consultation.est_assure && this.tarif_consultation.est_exclu == 0) && 
                (this.tmp_base_assurance == null || this.tmp_base_assurance === "") 
            ) {
                this.error_message = "La base assurance n'a pas été définie !"
                this.can_pay = false
                return;
            }

            if (
                (this.tarif_consultation.est_assure && this.tarif_consultation.est_exclu == 0) && 
                this.can_set_pac &&
                (this.tmp_prix_assure_clinique == null || this.tmp_prix_assure_clinique === "") 
            ) {
                this.error_message = "Le prix assuré de cette consultation n'a pas été défini !"
                this.can_pay = false
                return;
            }

            if (
                (this.tarif_consultation.est_assure && this.tarif_consultation.est_exclu == 0) && 
                this.can_set_pac &&
                this.tmp_prix_assure_clinique == 0
            ) {
                this.error_message = "Le prix assuré doit être supérieur à 0 !"
                this.can_pay = false
                return;
            }

            this.can_pay = true
        },

        /**
         * Recover the cost of a consultation 
         */
        getTarifConsultation(data, tarifEnCours) {
            this.clearErrorMessage()
            this.can_pay = false
            this.prix_assure = 0
            this.prix_assureur = 0
            this.total_a_payer = 0
            this.warning_exclusion = ""

            this.is_loading_tarif = true
            const chargementTarif = tarifEnCours || this.$store.dispatch('getTarifConsultation', data).then(() => true).catch(() => false)
            return chargementTarif.then(ok => {
                if (!ok) {
                    this.is_loading = false
                    this.is_loading_tarif = false
                    this.error_message = 'Impossible de charger le tarif de consultation. Réessayez.'
                    return false
                }
                if (!this.InsuranceIsValid(this.tarif_consultation.assur_est_expire)) {
                    this.warning_contrat_expire = "Le contrat d'assurrance de ce patient est expiré. En continuant, il sera traité comme un patient non assuré."
                }

                this.a_model_forfait = this.tarif_consultation.a_model_forfait
                // Taux de couverture défini depuis les paramètres, calculé avant info_assurance qui le transmet à la validation
                this.taux_couverture = (this.tarif_consultation.taux_couverture != "" || this.tarif_consultation.taux_couverture > 0)?''+(this.tarif_consultation.taux_couverture * 100):''

                // Si patient sous société forfaitaire; forcer le taux à 100%
                if (this.a_model_forfait === 1) {
                    this.taux_couverture = 100
                }
                // Info assurance
                this.info_assurance = {
                    taux_couverture: this.taux_couverture,
                    est_assure: this.tarif_consultation.est_assure,
                    est_expire: this.tarif_consultation.assur_est_expire,
                    assurance_id: (this.tarif_consultation.assureur_id != null)?this.tarif_consultation.assureur_id:'',
                    assurance: this.tarif_consultation.assureur,
                    souscripteur_id: (this.tarif_consultation.souscripteur_id != null)?this.tarif_consultation.souscripteur_id:'',
                    souscripteur: (this.tarif_consultation.souscripteur != null)?this.tarif_consultation.souscripteur:'',
                    assure_principal_id: (this.tarif_consultation.assure_principal_id != null)?this.tarif_consultation.assure_principal_id:'',
                    num_bon_is_required: this.tarif_consultation.num_bon_is_required
                }

                if (this.tarif_consultation.num_bon_is_required === 1 && !this.num_bon_societe && !this.date_expire_bon) {
                    this.fetchLatestPatientNumBonSociete()
                }

                /**
                 * Check if price is defined for the type of consultation
                 */
                this.prix_consultation = this.tarif_consultation.prix_clinique
                const prix_consultation_is_empty = this.validateStringNotEmpty(this.prix_consultation)
                
                if (prix_consultation_is_empty) {
                    this.is_loading = false
                    this.is_loading_tarif = false
                    this.error_message = "Le prix de cette consultation n'a pas été défini"
                    this.can_pay = false
                    return true
                }

                this.info_assurance.is_facture_compl = 1
                if (this.a_model_forfait === 1) {
                    this.info_assurance.is_facture_compl = 0
                }
                if (this.tarif_consultation.est_assure == 1 && this.tarif_consultation.est_exclu == 1) {
                    this.warning_exclusion = "Cette consultation est exclue. En continuant, le patient paiera la totalité des frais de la consultation."
                    this.info_assurance.is_facture_compl = 1
                }

                this.tmp_base_assurance = this.tarif_consultation.prix_base_calcul
                this.tmp_prix_assure_clinique = this.tarif_consultation.prix_assure_clinique
                
                /**
                 * Check whether the insurance base is defined when the patient is insured
                 */
                this.base_assurance = this.tarif_consultation.prix_base_calcul
                if (this.tarif_consultation.est_assure == 1 && this.tarif_consultation.est_exclu == 0) {
                    const base_is_empty = this.validateStringNotEmpty(this.tmp_base_assurance)

                    if (base_is_empty) {
                        this.calculate_prix_a_payer()
                        this.is_loading = false
                        this.is_loading_tarif = false

                        this.error_message = "La base assurance n'a pas été définie"
                        this.can_pay = false
                        
                        return true
                    }

                    // Check if is PA is set
                    if (this.can_set_pac && this.tmp_prix_assure_clinique == null && this.tarif_consultation.est_assure) {
                        this.error_message = "Le prix assuré d'une ou plusieurs prestations n'a pas été défini"
                        
                        this.can_pay = false
                        this.is_loading = false
                        this.is_loading_tarif = false
                        return true
                    }
                }

                this.tmp_prix_consultation = 0
                if (this.can_set_pac && this.tarif_consultation.est_assure) {
                    if (this.tarif_consultation.est_exclu == 0) {
                        this.tmp_prix_consultation = this.tmp_prix_assure_clinique
                    } else {
                        this.tmp_prix_consultation = this.prix_consultation
                    }
                } else {
                    this.tmp_prix_consultation = (this.prix_consultation > this.tmp_base_assurance)?this.prix_consultation:this.tmp_base_assurance
                }

                this.prix_net_consultation = this.tmp_prix_consultation

                this.calculate_prix_assure(this.taux_couverture)
                this.calculate_prix_assureur(this.taux_couverture)
                this.is_loading = false
                this.is_loading_tarif = false
                this.validator()
                return true
            })
        },

        calculate_prix_assure(taux_couverture) {
            let part_assure = 0
            if (this.tarif_consultation.est_exclu == 0 && this.tmp_base_assurance >= 0) {
                if (this.can_set_pac && this.tmp_prix_assure_clinique < this.tmp_base_assurance) {
                    let tmp_part_assureur = 0
                    if (this.tmp_base_assurance > 0) {
                        tmp_part_assureur = parseInt( (taux_couverture * this.tmp_base_assurance) / 100)
                    }

                    let total_pac = 0
                    if (this.tmp_prix_assure_clinique > 0) {
                        total_pac =  this.tmp_prix_assure_clinique

                        if (total_pac <= tmp_part_assureur) {
                            part_assure = 0
                        } else {
                            part_assure = total_pac - tmp_part_assureur
                        }
                    }
                } else {
                    
                    if (this.can_add_differential_computing.response == "Oui") {
                        let pac = 0
                        if (this.can_set_pac) {
                            pac = (this.tmp_prix_assure_clinique === '')?0:this.tmp_prix_assure_clinique
                        } else {
                            pac = this.tarif_consultation.prix_clinique
                        }

                        const prix_additionnel = (pac > this.tmp_base_assurance)?(pac - this.tmp_base_assurance):0

                        part_assure = ( Math.ceil( ( (100 - taux_couverture) / 100 ) * this.tmp_base_assurance ) +
                            + parseInt(prix_additionnel) )
                    } else {
                        part_assure = Math.ceil( ( (100 - taux_couverture) / 100 ) * this.tmp_base_assurance )
                    }
                }
            } else {
                // if (this.can_set_pac && this.tarif_consultation.est_assure) {
                //     part_assure = 0
                // } else {
                //     part_assure = this.tarif_consultation.prix_clinique
                // }
                part_assure = this.tarif_consultation.prix_clinique
            }

            this.prix_assure = part_assure
            this.calculate_prix_a_payer()
        },

        calculate_prix_assureur(taux_couverture) {
            let part_assureur = 0
            let total_pac =  this.tmp_prix_assure_clinique
            let tmp_part_assureur = 0

            if (this.tmp_base_assurance > 0) {
                tmp_part_assureur = parseInt( (taux_couverture * this.tmp_base_assurance) / 100)
            }

            if (this.can_set_pac) {
                if (total_pac <= tmp_part_assureur) {
                    part_assureur = total_pac
                } else {
                    part_assureur = tmp_part_assureur
                }
            } else {
                part_assureur = tmp_part_assureur
            }

            this.prix_assureur = part_assureur
        },

        checkIfCanApplyApportSocial() {
            let prix_apport_social = 0
            let can_apply_apport_social = true
            this.bon_consommables.forEach((consumable, index) => {
                const price = +consumable.consommable_prix_net

                if (this.selected_consumable[index]) {
                    if (consumable.consommable == 'Apport social') {
                        prix_apport_social = parseInt(price)
                    }
                }
            });
            if (this.prix_net_consultation < prix_apport_social) {
                can_apply_apport_social = false
            }
            return can_apply_apport_social
        },

        handleBaseAssuranceChange(selected_bon, is_base_assur) {
            if (is_base_assur) {
                const base_assur_input = document.getElementById('bassur')
                if (!base_assur_input) {
                    return;
                }
                let base_assur = base_assur_input.value

                if (base_assur == '') {
                    base_assur_input.value = 0
                } 

                const base_assur_is_empty = this.validateStringNotEmpty(base_assur)
                if (!base_assur_is_empty) {
                    base_assur = this.transformToNumber(base_assur)
                } else {
                    base_assur = 0
                }

                this.tmp_base_assurance = base_assur
                this.prix_net_consultation = (this.prix_consultation > this.tmp_base_assurance)?this.prix_consultation:this.tmp_base_assurance
            } else {
                const pac_input = document.getElementById('pac')
                if (!pac_input) {
                    return;
                }

                let pac = pac_input.value

                if (pac == '') {
                    pac_input.value = 0
                } 

                const pac_is_empty = this.validateStringNotEmpty(pac)
                if (!pac_is_empty) {
                    pac = this.transformToNumber(pac)
                } else {
                    pac = 0
                }

                this.tmp_prix_assure_clinique = pac
                this.prix_net_consultation = pac
                this.tmp_prix_consultation = pac
            }

            this.validator()

            // this.can_pay = true
            this.calculate_prix_assure(this.taux_couverture)
            this.calculate_prix_assureur(this.taux_couverture)

            const info_taxation = {
                group_taxation: selected_bon.group_taxation,
                prestation: selected_bon.consult_name,
                taxe_specifique: selected_bon.taxe_specifique,
                prix: this.prix_assure,
                qte: 1
            }
            this.updateGroupTaxation(info_taxation)
        },

        calculate_prix_a_payer() {
            if (!this.checkIfCanApplyApportSocial()) {
                this.can_apply_apport = false
                this.apport_social_error_message = "Le prix de cette consultation est inférieur à l'apport social"
                return;
            } else {
                this.can_apply_apport = true
                this.apport_social_error_message = ''
            }
            
            this.calc_total_prix_consommable()
            this.total_a_payer = 0

            const impot_additionel = (this.impot_aib > 0)?this.impot_aib:0
            const prix_consultation_is_empty = this.validateStringNotEmpty(this.prix_consultation)
            if (!prix_consultation_is_empty) {
                
                const prix_net = (this.prix_net_consultation > 0)?this.prix_net_consultation:0
                this.total_a_payer = parseInt(prix_net) + parseInt(this.total_consommable) + parseInt(impot_additionel)
            }
            
            if (this.tarif_consultation.est_assure == 1 && this.tarif_consultation.est_exclu == 0) {
                this.total_net_a_payer = this.prix_assure + this.total_consommable + parseInt(impot_additionel) + this.taxe_additionnel
            } else {
                this.total_net_a_payer = this.total_a_payer
            }

            // if (this.total_net_a_payer < 0) {
            //     this.can_pay = false
            //     this.error_message = "Vous ne pouvez plus appliquer un Apport social au montant dû"
            // } else {
            //     this.can_pay = true
            //     this.error_message = ""
            // }

        },

        calc_total_prix_consommable() {
            this.total_consommable = 0;
            this.prix_apport_social = 0

            this.bon_consommables.forEach((consumable, index) => {
                const price = +consumable.consommable_prix_net

                if (this.selected_consumable[index]) {
                    if (consumable.consommable == 'Apport social') {
                        this.prix_apport_social = parseInt(price)
                        this.total_consommable -= parseInt(price)
                    } else {
                        this.total_consommable += parseInt(price)
                    }
                }
                
            });
        },

        refreshTarification(taux) {
            this.is_reloading_tarif = true
            this.taux_couverture = taux
            this.info_assurance.taux_couverture = taux
            this.calculate_prix_assure(this.taux_couverture)
            this.calculate_prix_assureur(this.taux_couverture)

            setTimeout(() => {
                this.is_reloading_tarif = false
            }, 500);

            const info_taxation = {
                group_taxation: this.selected_type_consultation.group_taxation,
                prestation: this.selected_type_consultation.consult_name,
                taxe_specifique: this.selected_type_consultation.taxe_specifique,
                prix: this.prix_assure,
                qte: 1
            }
            this.updateGroupTaxation(info_taxation)
        },

        /**
         * Check if continue payment
         * @param {*} amount 
         */
        checkIfCanPay(amount) {
            amount = +amount
            if (amount == 0) {
                return false
            }
            return true
        },

        clearErrorMessage() {
            this.error_message = '',
            this.can_pay = true
        },

        setToPrintable() {
            this.is_printable = true
        },

        saveBonConsultation(data) {
            if (this.bon_creation_en_cours || this.is_printable) return
            this.bon_creation_en_cours = true
            if (!this.bon_creation_source) this.bon_creation_source = JSON.parse(JSON.stringify(data))
            // Le paiement précède historiquement la création du bon dans un autre service.
            // Ne jamais proposer un second encaissement si cette seconde étape échoue.
            this.consultation_payment_recorded = true
            const bon_data = this.bon_creation_payload || {
                user_id: this.userCredentials.user.id,
                patient_id: this.chosen_patient.id,
                type_consultation_id: this.selected_type_consultation.consult_id,
                moment_consultation_id: this.moment_selected,
                consultation_info: data.consultation_info,
                doctor_id: this.medecin_paiement ? this.medecin_paiement.id : null,
                medecin_reservation: this.medecin_reservation_paiement || null,
                etat_paiement: data.etat_paiement,
                nom_patient: this.chosen_patient.nom,
                sexe: this.chosen_patient.sexe,
                telephone: this.chosen_patient.telephone_mobile,
                assurance: this.tarif_consultation.assureur,
                societe_souscripteur: this.tarif_consultation.souscripteur,
                validite: this.duree_validite,
                num_bon_societe: this.num_bon_societe,
                date_expire_bon: this.date_expire_bon
            }
            this.bon_creation_payload = bon_data
            const tmpstamp = this.current_date.getTime()
            this.filename = 'Bon de consultation_'+tmpstamp

            this.$store.dispatch('storeBonConsultation', bon_data).then((response) => {
                if (response.success) {
                    this.successToast(response.deja_enregistre
                        ? 'Paiement déjà pris en compte : bon de consultation retrouvé.'
                        : data.payment_replayed
                            ? 'Paiement déjà pris en compte : bon de consultation créé.'
                            : 'Bon de consultation enregistré avec succès')
                    const honore = response.rendez_vous_honore
                    // RDV-010 : bon généré depuis un rendez-vous — note quand ce rendez-vous n'est pas celui que la Clinique
                    // a honoré (paiement différé, autre médecin, autre rendez-vous du jour)
                    const medecin_bon = Number(response.doctor_id) || (this.medecin_paiement ? this.medecin_paiement.id : null)
                    const note_rdv = this.rdv_bon ? note_rdv_apres_bon(this.rdv_bon, honore, data.etat_paiement, medecin_bon) : null
                    if (note_rdv) this.note_rdv_paiement = note_rdv.texte
                    // RDV-005 : la Clinique a honoré le rendez-vous du jour de ce patient avec ce médecin (RDV-010 : un autre
                    // rendez-vous que celui du bon est nommé par la note, sans ce message)
                    if (response.rendez_vous_honore) {
                        if (!(note_rdv && note_rdv.autre)) this.successToast('Rendez-vous du jour marqué honoré' + (honore.medecin_nom ? ' (' + honore.medecin_nom + ')' : '') + '.')
                        this.rdv_rafraichi++
                    }
                    this.consultation_generee_id = Number(response.consultation_id) || null
                    this.medecin_id = Number(response.doctor_id) || (this.medecin_paiement ? this.medecin_paiement.id : null)
                    this.reattribution_a_jour = !!this.consultation_generee_id
                    this.medecin_reservation = null
                    this.medecin_reservation_paiement = null

                    this.paiement_data = data.paiement
                    this.ticket_caisse_info = data.ticket_info

                    this.paiement_data.prestations.forEach(prestation => {
                        if (prestation.data_type == 'apport_social') {
                            this.total_prix_vente -= prestation.prix_vente
                        } else {
                            this.total_prix_vente += prestation.prix_vente
                        }
                        
                    });
                    
                    this.setToPrintable()
                } else {
                    this.msg_error = "Le paiement a été enregistré, mais le bon n’a pas pu être créé. Récupérez le bon ci-dessous sans repayer. " + (response.message || '')
                    this.warningToast(this.msg_error)
                }
                this.bon_creation_en_cours = false
            }).catch((error) => {
                const payload = error && error.response && error.response.data
                this.msg_error = "Le paiement a été enregistré, mais le bon n’a pas pu être créé. Récupérez le bon ci-dessous sans repayer. " + (payload && payload.message ? payload.message : '')
                this.warningToast(this.msg_error)
                this.bon_creation_en_cours = false
            })
        },

        recupererBonApresPaiement() {
            if (!this.bon_creation_source || this.bon_creation_en_cours || this.is_printable) return
            this.msg_error = ''
            this.saveBonConsultation(this.bon_creation_source)
        },

        printBonConsultation() {
            if (this.impressionMedecinBloquee) return
            this.can_print_consultation = true
            setTimeout(() => {
                window.print()
                this.can_print_consultation = false
            }, 200);
        },

        setPrestationUid() {
            const tm = new Date()

            let tmp_uid = this.selected_type_consultation.consult_name
            tmp_uid = tmp_uid.replace(" ", "_")
            tmp_uid = tmp_uid.replace("/", "_")
            tmp_uid = tmp_uid.toLowerCase()+''+tm.getTime()
            tmp_uid = tmp_uid.replace("  ", "_")
            tmp_uid = tmp_uid.replace(" ", "_")
            return tmp_uid
        },

        async saveBon() {
            if (this.save_loading || this.medecin_verifying) return
            this.medecin_verifying = true
            const validMedecin = await this.verifierMedecin()
            this.medecin_verifying = false
            if (!validMedecin) return
            this.msg_error = ''

            let chosen_consumables = []
            this.bon_consommables.forEach((consumable, index) => {
                if (this.selected_consumable[index]) {
                    chosen_consumables.push(consumable)
                }
            });

            const data = {
                data_type: 'bon_consultation',
                title: 'Bon de consultation',
                uid: this.setPrestationUid(),
                data_id: this.selected_type_consultation.consult_id,
                libelle: this.selected_type_consultation.consult_name,
                patient: this.chosen_patient,
                patient_id: this.chosen_patient.id,
                user_id: this.userCredentials.user.id,
                user: {
                    name: this.userCredentials.user.name,
                    titre: this.userCredentials.user.titre
                },
                prix_unitaire: this.tarif_consultation.prix_clinique,
                chosen_consumables: chosen_consumables,
                info_complementaire: {
                    medecin_id: this.medecin_id,
                    medecin_nom: this.medecinNom,
                    date_emission: this.today_date,
                    date_expiration: this.expiration_date,
                    duree_bon: this.validite_bon.duree_bon+' '+this.validite_bon.unite_duree,
                    est_assure: this.tarif_consultation.est_assure,
                    assurance: this.tarif_consultation.assureur,
                    societe_souscripteur: this.tarif_consultation.souscripteur,
                    taux_couverture: this.taux_couverture,
                    // N° de bon de la société et sa date d'expiration : repris par la Caisse à l'encaissement (04/10/2026).
                    num_bon_societe: this.num_bon_societe || '',
                    date_expire_bon: this.date_expire_bon || ''
                },
                
            }
            this.info_bon = data
            this.save_loading = true
            store_operation.saveBonMedical(data).then((response) => {
                if (response.success) {
                    this.successToast(response.message)
                    this.bon_is_printable = true
                    this.libererReservation()
                } else {
                    this.msg_error = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur s'est produite ! Merci de réesayer"
            })
        },

        printBonMedical() {
            $('.p-bon-medical').modal('show')
        },

        savePaiementForfait() {
            this.onPayment('comptant')
            setTimeout(() => {
                $('.cfrm-soc-op').modal('show')
            }, 100);
        },

        // Bon préparé par l'Accueil et ouvert depuis « Bons en attente » : son n° de bon et sa date d'expiration (04/10/2026).
        bonSocietePrepare() {
            const info = this.$store.getters.medecin_bon_prepare
            const match = this.is_pre_saved_bon && info &&
                Number(info.patient_id) === Number(this.chosen_patient.id) &&
                Number(info.type_id) === Number(this.selected_type_consultation.consult_id)
            if (!match || !(info.num_bon_societe || info.date_expire_bon)) return null
            return { num_bon_societe: info.num_bon_societe || '', date_expire_bon: info.date_expire_bon || '' }
        },

        fetchLatestPatientNumBonSociete() {
            this.info_bon_loading = true
            // Saisie de l'Accueil gardée telle quelle ; sinon le dernier bon valide du patient.
            const prepare = this.bonSocietePrepare()
            if (prepare) {
                this.num_bon_societe = prepare.num_bon_societe
                this.date_expire_bon = prepare.date_expire_bon
            }
            const data = {
                patient_id: this.chosen_patient.id
            }
            return store_consultation.getLatestPatientNumBonSociete(data).then((response) => {
                if (response.success) {
                    this.num_bon_societe = prepare ? prepare.num_bon_societe : response.data.num_bon_societe
                    this.date_expire_bon = prepare ? prepare.date_expire_bon : response.data.date_expiration_bon_societe
                    this.old_bon_societe = response.data.old_bon_societe
                }

                this.info_bon_loading = false
            }).catch(() => {
                this.info_bon_loading = false
            })  
        }
    }
}
